/**
 * @fileoverview Connect native numeric editing to shared form state through `utils.js`. The parent receives a number or null directly and owns validation, units, and persistence. This differs from the value-envelope contract of `AppCurrencyInput.js`.
 */

import React from 'react'
import { parseNumberInput } from './utils'

const inputStyle = {
    width: '100%',
    padding: '0.6rem 0.75rem',
    borderRadius: '6px',
    border: '1px solid var(--surface-border)',
    fontSize: '1rem',
    backgroundColor: 'var(--surface-section)',
    color: 'var(--text-color)'
}



function AppNumberInput({ id, value, onChange, step }) {
    const resolvedValue = value === null || value === undefined ? '' : value

    return (
        <input
            id={id}
            type="number"
            step={step}
            value={resolvedValue}
            onChange={(e) => onChange(parseNumberInput(e.target.value))}
            style={inputStyle}
        />
    )
}

export default AppNumberInput
